/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { useTranslation } from 'react-i18next';
import { DatePicker, RegularButton, HorizonDropdown, ICommonDropdownOption } from 'pg-ui-library';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { ICompany } from '../../../interfaces';
import { DateTime } from 'luxon';
import { CloseIcon, Content, ContentContainer, FormTitle, Header, BottomContainer } from './styles';

interface NewFiltersReviewModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  updateFilters: (
    startDate: Date,
    endDate: Date,
    selectedCompany: any,
    status: string,
    employmentType: string,
    changeType: string,
    employmentStatus: string
  ) => void;
}

export const NewFiltersReviewModal: React.FC<NewFiltersReviewModalProps> = ({ isOpen, setIsOpen, updateFilters }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState<string>('');
  const [employmentType, setEmploymentType] = useState<string>('');
  const [changeType, setChangeType] = useState<string>('');
  const [EmployemnetStatus, setEmployemnetStatus] = useState<string>('');
  const [selectedCompany, setSelectedCompany] = useState<string>('');
  const [currentCompany, setCurrentCompany] = useState<ICompany>();
  const { data, loading: companiesLoading } = useTypedSelector(state => state.companies);
  const { config } = useTypedSelector(state => state.config.data);

  interface Company {
    legalEntityId: string;
    name: string;
    identificationNumber: string;
  }

  const [dropdownOptionsCompany, setDropdownOptionsCompany] = useState<ICommonDropdownOption[]>([]);
  const defineInitialValue = () => {
    if (config?.selectedCompanyId) {
      const cpn = data.companies.find(company => company.id === config.selectedCompanyId);
      setCurrentCompany(cpn);
    } else {
      const cpn = data.companies[0];
      setCurrentCompany(cpn);
    }
  };

  useEffect(() => {
    const emptyCompany: ICompany = {
      id: '',
      name: 'All',
      legalEntityId: '',
    };
    const companiesWithEmpty = [...data.companies];
    companiesWithEmpty.unshift(emptyCompany);
    const cpnsOptions = companiesWithEmpty.map((item: ICompany) => ({
      key: item.id,
      label: item.name,
      value: item.legalEntityId,
    }));
    setDropdownOptionsCompany(cpnsOptions);
    if (data.companies.length) {
      defineInitialValue();
    }
  }, [data.companies.length]);

  const [dropdownEmpTypeOptions, setDropdownEmpTypeOptions] = useState<ICommonDropdownOption[]>([
    {
      key: 'internal',
      label: 'Internal',
      value: 'internal',
    },
    {
      key: 'External',
      label: 'External',
      value: 'external',
    },
    {
      key: '',
      label: 'Both',
      value: '',
    },
  ]);

  const [dropdownOptionsStatus, setDropdownOptionsStatus] = useState<ICommonDropdownOption[]>([
    {
      key: 'active',
      label: 'Active',
      value: 'active',
    },
    {
      key: 'inactive',
      label: 'In Active',
      value: 'inactive',
    },
    {
      key: 'Both',
      label: 'Both',
      value: 'both',
    },
  ]);

  const [dropdownOptionsChange, setDropdownOptionsChange] = useState<ICommonDropdownOption[]>([
    {
      key: '',
      label: 'All',
      value: '',
    },
    {
      key: 'new_hire',
      label: 'New Hire',
      value: 'new_hire',
    },
    {
      key: 'DEPENDENT',
      label: 'Dependent',
      value: 'DEPENDENT',
    },
    {
      key: 'open_enrollment',
      label: 'Open Enrollment',
      value: 'open_enrollment',
    },
    {
      key: 'qle',
      label: 'QLE',
      value: 'qle',
    },
  ]);

  const [dropdownOptionsRequestStatus, setDropdownOptionsRequestStatus] = useState<ICommonDropdownOption[]>([
    {
      key: '',
      label: 'All',
      value: '',
    },
    {
      key: 'pending',
      label: 'Pending',
      value: 'pending',
    },
    {
      key: 'approved',
      label: 'Approved',
      value: 'approved',
    },
    {
      key: 'declined',
      label: 'Declined',
      value: 'declined',
    },
  ]);

  const [startDate, setStartDate] = useState(DateTime.now().minus({ days: 14 }).toJSDate());
  const [endDate, setEndDate] = useState(new Date());

  const filterapply = () => {
    updateFilters(startDate, endDate, selectedCompany, status, employmentType, changeType, EmployemnetStatus);
    setIsOpen(false);
  };

  const clearapply = () => {
    setStatus('');
    setEmploymentType('');
    setSelectedCompany('');
    setStartDate(DateTime.now().minus({ days: 14 }).toJSDate());
    setEndDate(new Date());
    setChangeType('');
    setEmployemnetStatus('');
  };

  const handleDateChange = (date: Date | null, setDate: Function) => {
    setDate(date);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          backgroundColor: '#F3F4F8',
          margin: 'auto',
          width: '1310px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '20px',
          gap: '20px',
        },
      }}
    >
      <Header>
        <FormTitle>{t('employeeReviewChanges.newFilters')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleModalClose()} />
      </Header>
      <ContentContainer>
        <Content>
          <div style={{ minWidth: '130px' }}>
            <DatePicker
              id="startDate"
              name="startDate"
              label="Start Date"
              onChange={e => handleDateChange(e, setStartDate)}
              selected={startDate}
              maxDate={startDate}
              dateFormat="MM/dd/yyyy"
            />
          </div>
          <p style={{ padding: '15px 0px' }}>to</p>
          <div style={{ minWidth: '130px' }}>
            <DatePicker
              id="endDate"
              name="endDate"
              label="End Date"
              onChange={e => handleDateChange(e, setEndDate)}
              selected={endDate}
              maxDate={endDate}
              dateFormat="MM/dd/yyyy"
            />
          </div>
          <div>
            <label style={{ marginLeft: '15px' }}>Status</label>
            <HorizonDropdown
              setValue={(value: string) => {
                setStatus(value);
              }}
              placeholder="Choose a Status"
              value={status}
              label=""
              options={dropdownOptionsStatus}
              selectStyle={{
                width: '14rem',
                maxWidth: '500px',
                marginTop: '5px',
                height: '35px',
              }}
            />
          </div>
          <div>
            <label style={{ marginLeft: '15px' }}>Status</label>
            <HorizonDropdown
              setValue={(value: string) => {
                setEmploymentType(value);
              }}
              label=""
              options={dropdownOptionsRequestStatus}
              value={employmentType}
              selectStyle={{
                width: '15rem',
                maxWidth: '500px',
                marginTop: '5px',
                height: '35px',
              }}
            />
          </div>
          <div>
            <label style={{ marginLeft: '15px' }}>Employment Type</label>
            <HorizonDropdown
              setValue={(value: string) => {
                setEmployemnetStatus(value);
              }}
              label=""
              options={dropdownEmpTypeOptions}
              value={EmployemnetStatus}
              selectStyle={{
                width: '15rem',
                maxWidth: '500px',
                marginTop: '5px',
                height: '35px',
              }}
            />
          </div>
          <div>
            <label style={{ marginLeft: '15px' }}>Change Type</label>
            <HorizonDropdown
              setValue={(value: string) => {
                setChangeType(value);
              }}
              label=""
              options={dropdownOptionsChange}
              value={changeType}
              selectStyle={{
                width: '14rem',
                maxWidth: '500px',
                marginTop: '5px',
                height: '35px',
              }}
            />
          </div>
          <div>
            <label style={{ marginLeft: '15px' }}>Company ID</label>
            <HorizonDropdown
              setValue={(value: string) => {
                setSelectedCompany(value);
              }}
              label=""
              options={dropdownOptionsCompany}
              value={selectedCompany}
              selectStyle={{
                width: '16rem',
                maxWidth: '500px',
                marginTop: '5px',
                height: '35px',
              }}
            />
          </div>
        </Content>
        <BottomContainer>
          <RegularButton onClick={() => filterapply()}>{t('global.button.search')}</RegularButton>
          <RegularButton onClick={() => clearapply()}>{t('global.button.clear')}</RegularButton>
        </BottomContainer>
      </ContentContainer>
    </ReactModal>
  );
};
